
import React, { useEffect, useRef, useState } from "react"
import { flexRender } from "@tanstack/react-table"
import { DnDColumnHeader } from "./DnDColumnHeader"
import { DnDGroupingContainer } from "./DnDGroupingContainer"
import { Dropdown, Modal } from "react-bootstrap"
import { useDownloadExcel } from "react-export-table-to-excel"
import DebouncedInput from "./DebouncedInput"
import ActionButtons from "./ActionButtons"
import dayjs from "dayjs"
import "./styles.table.css"

function getTableHeaderGroups(table, tg) {
  if (tg === "left") {
    return [table.getLeftHeaderGroups(), table.getLeftFooterGroups()]
  }

  if (tg === "right") {
    return [table.getRightHeaderGroups(), table.getRightFooterGroups()]
  }

  if (tg === "center") {
    return [table.getCenterHeaderGroups(), table.getCenterFooterGroups()]
  }

  return [table.getHeaderGroups(), table.getFooterGroups()]
}

function getRowGroup(row, tg) {
  if (tg === "left") return row.getLeftVisibleCells()
  if (tg === "right") return row.getRightVisibleCells()
  if (tg === "center") return row.getCenterVisibleCells()
  return row.getVisibleCells()
}

export const FaastSmartTable = props => {
  const {
    table,
    exportedFileName,
    title,
    customRender,
    grouping,
    pinning,
    expanded,
    setGrouping,
    globalFilter,
    setGlobalFilter,
    hideTableOptions,
    allowColumnSubcomponents,
    allowNativeExcelDownload,
    allowGlobalFilter,
    handleChangeCurrentProfile,
    handleDeleteProfile,
    handleSaveProfile,
    profiles,
    currentProfile,
    allowProfiling,
    tableActions,
    showPagination,
    ...restProps
  } = props
  const refDownload = useRef(null)
  const [isGrouping, setIsGrouping] = useState(
    Boolean(table.getState()?.grouping?.length)
  )

  const leftBodyRef = useRef(null)
  const rightBodyRef = useRef(null)
  const centerBodyRef = useRef(null)

  const [showVisibility, setShowVisibility] = useState(false)
  const [showProfileSelection, setShowProfileSelection] = useState(false)
  const { onDownload } = useDownloadExcel({
    currentTableRef: refDownload.current,
    filename:
    (exportedFileName ?? (typeof title === "string" ? title : "Tabla")) +
    "_" +
    dayjs().format("YYYY_MM_DDTHH:mm:ss")
  })

  useEffect(() => {
    setIsGrouping(Boolean(grouping.length))
  }, [grouping])

  useEffect(()=>{
    let centerArr = []
    Array.from(centerBodyRef?.current?.children).forEach(element => {
      centerArr.push(element.getBoundingClientRect().height)
    });
    
    let leftArr = []
    Array.from(leftBodyRef?.current?.children).forEach(element => {
      leftArr.push(element.getBoundingClientRect().height)
    });
    
    let rightArr = []
    Array.from(rightBodyRef?.current?.children).forEach(element => {
      rightArr.push(element.getBoundingClientRect().height)
    });


    Array.from(centerBodyRef?.current?.children).forEach((element,index) => {
      if((!pinning.right?.length || centerArr[index] === rightArr[index]) && (!pinning.left?.length || centerArr[index] === leftArr[index])) return null
      element?.children?.forEach?.(el2=>el2.setAttribute("style",`height:${Number.parseInt(Math.max(centerArr[index] ?? 0,rightArr[index] ?? 0,leftArr[index] ?? 0))}px; min-height:${Number.parseInt(Math.max(centerArr[index] ?? 0,rightArr[index] ?? 0,leftArr[index] ?? 0))+1}px; max-height:${Number.parseInt(Math.max(centerArr[index] ?? 0,rightArr[index] ?? 0,leftArr[index] ?? 0))+1}px`))
       
    });
    Array.from(leftBodyRef?.current?.children).forEach((element,index) => {
      if((!pinning.right?.length || centerArr[index] === rightArr[index]) && (!pinning.left?.length || centerArr[index] === leftArr[index])) return null
      element?.children?.forEach?.(el2=>el2.setAttribute("style",`height:${Number.parseInt(Math.max(centerArr[index] ?? 0,rightArr[index] ?? 0,leftArr[index] ?? 0))}px; min-height:${Number.parseInt(Math.max(centerArr[index] ?? 0,rightArr[index] ?? 0,leftArr[index] ?? 0))+1}px; max-height:${Number.parseInt(Math.max(centerArr[index] ?? 0,rightArr[index] ?? 0,leftArr[index] ?? 0))+1}px`))
    });
    Array.from(rightBodyRef?.current?.children).forEach((element,index) => {
      if((!pinning.right?.length || centerArr[index] === rightArr[index]) && (!pinning.left?.length || centerArr[index] === leftArr[index])) return null
      element?.children?.forEach?.(el2=>el2.setAttribute("style",`height:${Number.parseInt(Math.max(centerArr[index] ?? 0,rightArr[index] ?? 0,leftArr[index] ?? 0))}px; min-height:${Number.parseInt(Math.max(centerArr[index] ?? 0,rightArr[index] ?? 0,leftArr[index] ?? 0))+1}px; max-height:${Number.parseInt(Math.max(centerArr[index] ?? 0,rightArr[index] ?? 0,leftArr[index] ?? 0))+1}px`))
    });
  })

  return (
    <div className="w-100" style={{
      overflow: 'clip'
    }}>
      <div className="d-flex justify-content-between px-2">
        <div className="d-flex flex-column">
          <span className="h3 align-self-center mb-0">{title}</span>
          <span className="fs-6 text-secondary text-uppercase">
            {currentProfile ?? ""}
          </span>
        </div>
        <div className="d-flex">
          {allowGlobalFilter && (
            <div className="p-2">
              <DebouncedInput
                value={globalFilter ?? ""}
                onChange={value => setGlobalFilter(String(value))}
                className="mx-1 p-2 font-lg border border-block rounded"
                placeholder="Buscar ..."
              />
            </div>
          )}
          {allowNativeExcelDownload && (
            <Dropdown className="align-self-center">
              <Dropdown.Toggle
                // variant="primary"
                id="dropdown-basic"
                className="btn align-self-center my-auto h-100 py-2 btn-label-brand btn-bold"
                style={{ borderColor: 'transparent'}}
              >
                Descargar
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <button
                  type="button"
                  onClick={() =>onDownload()}
                  className="dropdown-item"
                  style={{ cursor: "pointer" }}
                >
                  {" "}
                  Exportar Excel{" "}
                </button>
              </Dropdown.Menu>
            </Dropdown>
          )}

          {allowProfiling && (
            <Dropdown className="align-self-center">
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                className="btn align-self-center my-auto h-100 py-2 ms-2 "
              >
                Perfiles
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {currentProfile ? (
                  <button
                    type="button"
                    onClick={() => {
                      handleSaveProfile?.(false).catch(e => console.error(e))
                    }}
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    Guardar Perfil Actual{" "}
                  </button>
                ) : null}
                <button
                  type="button"
                  onClick={() => {
                    handleSaveProfile?.(true).catch(e => console.error(e))
                  }}
                  className="dropdown-item"
                  style={{ cursor: "pointer" }}
                >
                  {" "}
                  Nuevo Perfil{" "}
                </button>
                {profiles && profiles.length ? (
                  <button
                    type="button"
                    onClick={() => setShowProfileSelection(true)}
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    Seleccionar Perfil{" "}
                  </button>
                ) : null}
                {currentProfile ? (
                  <button
                    type="button"
                    onClick={() => {
                      handleDeleteProfile?.().catch(e => console.error(e))
                    }}
                    className="dropdown-item text-danger"
                    style={{ cursor: "pointer" }}
                  >
                    {" "}
                    Eliminar Perfil{" "}
                  </button>
                ) : null}
              </Dropdown.Menu>
            </Dropdown>
          )}
          {hideTableOptions ? null : (
            <Dropdown className="align-self-center ms-2" drop="down">
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                className="btn align-self-center my-auto h-100 py-2"
              >
                Opciones
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {restProps.allowColumnGrouping && (
                  <Dropdown.Item
                    style={{ cursor: "pointer" }}
                    onClick={
                      isGrouping
                        ? () => {
                            table.setState(old => {
                              return {
                                ...old,
                                grouping: []
                              }
                            })
                            setIsGrouping(false)
                          }
                        : () => setIsGrouping(true)
                    }
                  >
                    {isGrouping ? `Desagrupar` : `Agrupar`}
                  </Dropdown.Item>
                )}
                {restProps.allowColumnVisibility && (
                  <Dropdown.Item
                    onClick={() => {
                      setShowVisibility(true)
                    }}
                  >
                    Visibilidad de Columnas
                  </Dropdown.Item>
                )}
              </Dropdown.Menu>
            </Dropdown>
          )}
          {tableActions ?? null}
        </div>
      </div>
      {restProps.allowColumnGrouping && isGrouping && (
        <div>
          <DnDGroupingContainer
            columns={table.getAllLeafColumns()}
            groupedColumns={grouping}
            setGrouping={setGrouping}
          />
        </div>
      )}
      <div
        className="w-100 d-flex position-relative px-2 my-2"
        style={{
          overflow: "auto"
        }}
      >
        {["left", "center", "right"].map(hg => (
          <table
            style={{
              position: ["left", "right"].includes(hg) ? "sticky" : "static",
              left: hg === "left" ? "-0.5rem" : undefined,
              right: hg === "right" ? "-0.5rem" : undefined,
              backgroundColor: '#fff',
              zIndex: ['left','right'].includes(hg) ? '9' : undefined,
              fontSize: '13px'
            }}
            key={hg}
            className="tabletankstack"
          >
            <thead style={{
              border: '1px solid #ebedf2',
              backgroundColor: '#eceaea'
            }}>
              {getTableHeaderGroups(table, hg)[0].map(headerGroup => (
                <tr className="tabletankstackthtd" key={headerGroup.id}>
                  {headerGroup.headers.map(header => (
                    <DnDColumnHeader
                      header={header}
                      table={table}
                      {...restProps}
                      key={header.id}
                    />
                  ))}
                </tr>
              ))}
            </thead>
            <tbody className="tabletankstackbody" ref={hg=== 'left' ? leftBodyRef : hg === 'right' ? rightBodyRef : centerBodyRef}>
              { table.getRowModel().rows.length == 0 ?
                  hg === "center" && (
                    <tr>
                      <td style={{ textAlign:'center' }} colSpan={restProps.lengthHeaderColumn}>No hay datos disponibles. </td>
                    </tr>
                  ):
                  table.getRowModel().rows.map(row => {
                  return(
                  <React.Fragment key={row.id}>
                    <tr className="tabletankstackthtd" key={row.id}>
                      {getRowGroup(row, hg).map(cell => {
                        return (
                          <td 
                            className="tabletankstackthtd"
                            {...{
                              key: cell.id,
                              style: {
                                background: cell.getIsGrouped()
                                  ? "white"
                                  : cell.getIsAggregated()
                                  ? "white"
                                  : cell.getIsPlaceholder()
                                  ? "var(--bs-light)"
                                  : "var(--bs-light)",
                                minWidth: cell.column.columnDef?.meta?.minWidth,
                              }
                            }}
                          >
                            {cell.getIsGrouped() ? (
                              // If it's a grouped cell, add an expander and row count
                              <>
                                <button
                                  {...{
                                    type:"button",
                                    onClick: row.getToggleExpandedHandler(),
                                    style: {
                                      cursor: row.getCanExpand()
                                        ? "pointer"
                                        : "normal",
                                      border: "none",
                                      display:"inline-flex",
                                      backgroundColor: "transparent"
                                    },
                                    className: ""
                                  }}
                                >
                                  <span>{row.getIsExpanded() ? "↓" : "→"}</span>{" "}
                                  {flexRender(
                                    cell.column.columnDef.cell,
                                    cell.getContext()
                                  )}{" "}
                                  <span className="text-muted">
                                    ({row.subRows.length})
                                  </span>
                                </button>
                              </>
                            ) : cell.getIsAggregated() ? (
                              // If the cell is aggregated, use the Aggregated
                              // renderer for cell
                              flexRender(
                                cell.column.columnDef.aggregatedCell ??
                                  cell.column.columnDef.cell,
                                cell.getContext()
                              ) ?? <span style={{
                                visibility: 'hidden'
                              }}>Test</span>
                            ) : cell.getIsPlaceholder() ? (<span style={{
                                visibility: 'hidden'
                              }}>Test</span>) : ( // For cells with repeated values, render null
                              // Otherwise, just render the regular cell
                              flexRender(
                                cell.column.columnDef.cell,
                                cell.getContext()
                              ) ?? <span style={{
                                visibility: 'hidden'
                              }}>Test</span>
                            )}
                          </td>
                        )
                      })}
                    </tr>
                    {allowColumnSubcomponents &&
                      row.getIsExpanded() &&
                      !row.getIsGrouped() &&
                      Boolean(customRender) && ((hg === 'left' && pinning.left?.length) || (hg === 'center') || (hg === 'right' && pinning.right?.length)) && (
                        <tr className="tabletankstackthtd">
                          <td className="tabletankstackthtd" colSpan={row.getVisibleCells().length}>
                            {hg === "center" ? (customRender?.(row)) : null}
                          </td>
                        </tr>
                      )}
                  </React.Fragment>
              )})}
            </tbody>
          </table>
        ))}
      </div>
      { showPagination &&
        <div className="mt-3">
          <ActionButtons
            getSelectedRowModel={table.getSelectedRowModel}
            hasNextPage={table.getCanNextPage()}
            hasPreviousPage={table.getCanPreviousPage()}
            nextPage={table.nextPage}
            pageCount={table.getPageCount()}
            pageIndex={table.getState().pagination.pageIndex}
            pageSize={table.getState().pagination.pageSize}
            previousPage={table.previousPage}
            setPageIndex={table.setPageIndex}
            setPageSize={table.setPageSize}
            totalRows={table.getPrePaginationRowModel().rows.length}
            totalRowsView={table.getPrePaginationRowModel().rows }
          />
        </div>
      }
      <Modal
        show={showVisibility}
        onHide={() => setShowVisibility(false)}
        onBackdropClick={() => setShowVisibility(false)}
        size="sm"
        centered
      >
        <Modal.Body title="Visibilidad">
          <div className="p-2 inline-block">
            <div className="px-1 border p-2 border-b border-black">
              <label className="">
                <input
                  type="checkbox"
                  checked={table.getIsAllColumnsVisible()}
                  onChange={table.getToggleAllColumnsVisibilityHandler()}
                  className="me-2"
                />
                Mostrar/Ocultar Todas
              </label>
            </div>
            {table.getAllLeafColumns().map(column => {
              return (
                <div key={column.id} className="px-1">
                  <label>
                    <input
                      type="checkbox"
                      checked={column.getIsVisible()}
                      onChange={column.getToggleVisibilityHandler()}
                      className="me-2"
                    />
                    {column.id}
                  </label>
                </div>
              )
            })}
          </div>
          <div className="d-flex gap-2">
            <button
              type="button"
              onClick={() => {
                setShowVisibility(false)
              }}
              className="btn btn-primary w-100"
            >
              Aceptar
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showProfileSelection}
        onHide={() => setShowProfileSelection(false)}
        onBackdropClick={() => setShowProfileSelection(false)}
        size="sm"
        centered
      >
        <Modal.Body title="Perfiles">
          <div className="w-100 d-flex flex-column gap-2 mb-3">
            {profiles?.map((p,i) => (
              <button
                key={i}
                type="button"
                className={
                  "menu-item py-2" +
                  (p.id === currentProfile ? " bg-secondary text-white" : "")
                }
                style={{ border: "none" }}
                onClick={() => {
                  handleChangeCurrentProfile?.(p.id)?.catch(e =>
                    console.error(e)
                  )
                }}
              >
                {p.id}
              </button>
            ))}
          </div>
          <div className="d-flex gap-2">
            <button
              type="button"
              onClick={() => {
                setShowProfileSelection(false)
              }}
              className="btn btn-primary w-100"
            >
              Aceptar
            </button>
          </div>
        </Modal.Body>
      </Modal>








      {/*
      ALERT!!!!
      Even if it looks the same as above this component works as a blueprint for excel axport 
      ... only remove it if you are removing excel export
      */}
      <table className="d-none" ref={refDownload}>
        <thead>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header =>
                !header.column.columnDef?.meta?.hideInExport ? (
                  <DnDColumnHeader
                    header={header}
                    table={table}
                    key={header.id}
                  />
                ) : null
              )}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getPrePaginationRowModel().rows.map(row => (
            <React.Fragment key={row.id}>
              <tr key={row.id}>
                {getRowGroup(row, undefined).map(cell =>
                  !cell.column.columnDef?.meta?.hideInExport ? (
                    <td
                      {...{
                        key: cell.id,
                        style: {
                          background: cell.getIsGrouped()
                            ? "white"
                            : cell.getIsAggregated()
                            ? "white"
                            : cell.getIsPlaceholder()
                            ? "var(--bs-light)"
                            : "var(--bs-light)"
                        }
                      }}
                    >
                      {cell.getIsGrouped() ? (
                        // If it's a grouped cell, add an expander and row count
                        <>
                          <button
                            {...{
                              type:"button",
                              onClick: row.getToggleExpandedHandler(),
                              style: {
                                cursor: row.getCanExpand()
                                  ? "pointer"
                                  : "normal",
                                border: "none",
                                backgroundColor: "transparent"
                              },
                              className: ""
                            }}
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext()
                            )}{" "}
                            <span className="text-muted">
                              ({row.subRows.length})
                            </span>
                          </button>
                        </>
                      ) : cell.getIsAggregated() ? (
                        // If the cell is aggregated, use the Aggregated
                        // renderer for cell
                        flexRender(
                          cell.column.columnDef.aggregatedCell ??
                            cell.column.columnDef.cell,
                          cell.getContext()
                        )
                      ) : cell.getIsPlaceholder() ? null : ( // For cells with repeated values, render null
                        // Otherwise, just render the regular cell
                        flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )
                      )}
                    </td>
                  ) : null
                )}
              </tr>
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  )
}
